/**
 * @file AI 補助ページの一覧 (資料 id → 補助ページ)。
 *
 * @what: 本だなのカードとルーティングがここを引く。追加はこの配列に 1 行足すだけ。
 * @why: 補助ページは資料の属性ではなく web 側のコンテンツなので、サーバに器を作らず
 *   静的な対応表で持つ (代表 2026-08-27)。語 → ページ のさくいんは資料の索引
 *   (StudySourceIndex、/sources/{id}/index) に移したので、ここには置かない。
 * @failure: id 重複はテストで検出する。未知の sourceId ならリンクが出ないだけ。
 */

import { lazy } from "react";
import type { StudyAidDef } from "./types";

export const STUDY_AIDS: readonly StudyAidDef[] = [
  {
    id: "games",
    sourceId: "sansuu-2sai",
    title: "ゲーム別ガイド",
    tagline: "本に出てくる遊びを、教具ごとにまとめて引けます",
    Component: lazy(() => import("./views/SansuuGamesView")),
  },
  {
    id: "timeline",
    sourceId: "tetsugaku-50",
    title: "タイムライン",
    tagline: "50 人を生きた時代の順に並べて見わたせます",
    Component: lazy(() => import("./views/TetsugakuTimelineView")),
  },
  {
    id: "influence",
    sourceId: "tetsugaku-50",
    title: "つながり",
    tagline: "だれの考えがだれに受け継がれたかをたどれます",
    Component: lazy(() => import("./views/TetsugakuInfluenceView")),
  },
  {
    id: "catalog",
    sourceId: "scenario-jiten-100",
    title: "パターン一覧",
    tagline: "100 のストーリーパターンをカテゴリとキーワードで引けます",
    Component: lazy(() => import("./views/ScenarioCatalogView")),
  },
];

/** 資料に紐づく補助ページの一覧 (無ければ空配列)。 */
export function aidsForSource(sourceId: string): StudyAidDef[] {
  return STUDY_AIDS.filter((a) => a.sourceId === sourceId);
}

/** 補助ページ 1 点 (無ければ undefined)。 */
export function findAid(sourceId: string, aidId: string): StudyAidDef | undefined {
  return STUDY_AIDS.find((a) => a.sourceId === sourceId && a.id === aidId);
}
